export { record } from './record'
export { serializeNodeWithId, serializeDocument, SerializationContextStatus } from './serialization'
export { createElementsScrollPositions } from './elementsScrollPositions'
export { ShadowRootsController } from './shadowRootsController'
